
import {Vue, Component, Prop, Watch} from "vue-property-decorator";

@Component({

})
export default class GenelIstatistikPerformansGrafik extends Vue{

  options = {
    series: [{
      name: 'Performans',
      data: [10,7,9,11,16,6,20,28,15,5,22,13],
    }],
    chart: {
      type: 'line',
    },
    stroke: {
      width: 1,
      curve: 'smooth'
    },
    xaxis: {
      categories: ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
      labels: {
        rotate: -80,
        show: true,
        style: {
          fontSize: '10px',
        }
      }
    },
    fill: {
      colors: ["#2196F3"],
    },
    yaxis: {
      min: 0,
      max: 50,
      tickAmount: 5
    }
  };


}
